<script>

export default {
  name: 'Contact',
  data: function (){
    return {
    horaires: [
      {'day': 'Lundi', 'morning':'', 'afternoon': '15h00 - 19h30'},
      {'day': 'Mardi', 'morning':'08h30 - 12h30', 'afternoon': '15h00 - 19h30'},
      {'day': 'Mercredi', 'morning':'08h30 - 12h30', 'afternoon': '15h00 - 19h30'},
      {'day': 'Jeudi', 'morning':'08h30 - 12h30', 'afternoon': '15h00 - 19h30'},
      {'day': 'Vendredi', 'morning':'08h30 - 12h30', 'afternoon': '15h00 - 19h30'},
      {'day': 'Samedi', 'morning':'08h30 - 12h30', 'afternoon': '15h00 - 19h30'},
      {'day': 'Dimanche', 'morning':'08h30 - 12h00', 'afternoon': ''}
    ]
  }
  },
  methods: {
    isCurrentDay(index) {
      const currentDate = new Date();
      let numDay = index == 7 ? 0 : (index + 1);

     if(currentDate.getDay() == numDay){
       return 'actived'
     }
     return ''
    }
  },

}
</script>
<template>
  <div id="contact" class="page">
    <div class="w-full px-4">
      <div class="flex flex-wrap">
        <div class="w-full lg:w-1/2 ">
          <div class="title_page">Horaires</div>
          <div class="text-xl py-4">Votre magasin Chez Thomas est ouvert le</div>
         <div v-for="(horaire, key) in horaires" :key="horaire.day" class="flex" :class="isCurrentDay(key)">
           <div class="w-1/3 p-2">{{ horaire.day }}</div>
           <div class="w-1/3 p-2">{{ horaire.morning }}</div>
           <div class="w-1/3 p-2">{{ horaire.afternoon }}</div>
         </div>
        </div>
        <div class="w-full lg:w-1/2">
          <div class="title_page">Nous trouver</div>
          <div class="flex flex-wrap">
            <div class="w-full">
              <svg width="300" height="300" class="mx-auto" viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg"><title/><g id="Store"><path d="M79.5,72H79V47a3.57,3.57,0,0,0,3.25-3.54v0s0,0,0,0a.4.4,0,0,0-.07-.18.08.08,0,0,0,0,0L76,34.34V31h.5a.5.5,0,0,0,.5-.5v-3a.5.5,0,0,0-.5-.5H68V21.5A2.5,2.5,0,0,0,65.5,19h-35A2.5,2.5,0,0,0,28,21.5V27H19.5a.5.5,0,0,0-.5.5v3a.5.5,0,0,0,.5.5H20v3.34l-6.16,8.87a.08.08,0,0,0,0,0,.4.4,0,0,0-.07.18s0,0,0,0v0A3.57,3.57,0,0,0,17,47V72h-.5A2.5,2.5,0,0,0,14,74.5v2a.5.5,0,0,0,.5.5h67a.5.5,0,0,0,.5-.5v-2A2.5,2.5,0,0,0,79.5,72Zm-.77-25.94A.56.56,0,0,0,78.5,46a.39.39,0,0,0-.18,0,2.59,2.59,0,0,1-2.16-2h5A2.57,2.57,0,0,1,78.73,46.06ZM29.75,35,26.2,43h-5l4.44-8Zm20.82,0v8H45.43V35Zm5.19,0,.89,8H51.57V35Zm14.56,0,4.44,8H69.83l-3.56-8Zm-5.15,0,3.56,8h-5L61,35ZM60,35l2.67,8h-5l-.89-8ZM44.43,43H39.35l.89-8h4.19Zm-6.08,0h-5L36,35h3.22ZM32.3,43h-5l3.56-8H35ZM26,44a2.56,2.56,0,0,1-5,0Zm6.14,0a2.57,2.57,0,0,1-5,0Zm6.14,0a2.57,2.57,0,0,1-5,0Zm6.13,0a2.57,2.57,0,0,1-5,0Zm6.14,0a2.57,2.57,0,0,1-5,0Zm6.14,0a2.57,2.57,0,0,1-5,0Zm6.13,0a2.57,2.57,0,0,1-5,0Zm6.14,0a2.57,2.57,0,0,1-5,0Zm6.13,0a2.56,2.56,0,0,1-5,0Zm.85-1-4.45-8h3.78l5.55,8ZM76,28v2H68V28ZM29,21.5A1.5,1.5,0,0,1,30.5,20h35A1.5,1.5,0,0,1,67,21.5V30H29V21.5ZM20,28h8v2H20Zm8.5,3H75v3H21V31Zm-7.74,4h3.78l-4.45,8H15.21Zm-6,9h5a2.59,2.59,0,0,1-2.16,2,.39.39,0,0,0-.18,0,.56.56,0,0,0-.23.06A2.57,2.57,0,0,1,14.8,44ZM18,47a3.58,3.58,0,0,0,2.39-1.71,3.53,3.53,0,0,0,6.13,0,3.54,3.54,0,0,0,6.14,0,3.54,3.54,0,0,0,6.14,0,3.53,3.53,0,0,0,6.13,0,3.54,3.54,0,0,0,6.14,0,3.53,3.53,0,0,0,6.13,0,3.54,3.54,0,0,0,6.14,0,3.54,3.54,0,0,0,6.14,0,3.53,3.53,0,0,0,6.13,0A3.58,3.58,0,0,0,78,47V72H41V54.5A2.5,2.5,0,0,0,38.5,52h-10A2.5,2.5,0,0,0,26,54.5V72H18ZM40,72H27V54.5A1.5,1.5,0,0,1,28.5,53h10A1.5,1.5,0,0,1,40,54.5Zm41,4H15V74.5A1.5,1.5,0,0,1,16.5,73h63A1.5,1.5,0,0,1,81,74.5Z"/><path d="M46.5,67h23a.5.5,0,0,0,.5-.5v-10A4.51,4.51,0,0,0,65.5,52h-15A4.51,4.51,0,0,0,46,56.5v10A.5.5,0,0,0,46.5,67ZM47,56.5A3.5,3.5,0,0,1,50.5,53h15A3.5,3.5,0,0,1,69,56.5V66H47Z"/><circle cx="35" cy="22" r="1"/><circle cx="35" cy="28" r="1"/><circle cx="60" cy="22" r="1"/><circle cx="60" cy="28" r="1"/></g></svg>
            </div>
            <div class="w-full text-center text-2xl -mt-5">7 RUE DE LA REPUBLIQUE, 17270 CERCOUX</div>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">

@import "../assets/css/color";

.actived{
  background: #8d1f22;
  color: #FFFFFF;
  font-weight: bold;
}


</style>